import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';
import { useIntl } from 'react-intl';
import Delete from '@mui/icons-material/Delete';
import messages from './messages';

type AttachmentListItemProps = {
  attachment: {
    id: number;
    fileName?: string;
  };
  onRemoveAttachment: () => void;
};

const AttachmentListItem = (props: AttachmentListItemProps) => {
  const intl = useIntl();
  return (
    <ListItem dense disableGutters>
      <ListItemText
        primary={props.attachment.fileName}
        secondary={`/api/NewsEntries/Attachments/${props.attachment.id}`}
      />
      <ListItemSecondaryAction>
        <IconButton
          edge="end"
          aria-label={intl.formatMessage(messages.deleteAttachment)}
          onClick={props.onRemoveAttachment}
          size="large"
        >
          <Delete />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default AttachmentListItem;
